var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNbWifiCast(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 52 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B093E4D2-92BB-484F-ABC9-D333B2B145DC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home-wifi-access-create1",
    transform: "translate(-115.000000, -515.000000)",
    fill: "#76778C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.132722,546.094583 C118.154633,546.094583 118.983056,546.930971 118.983056,547.962708 C118.983056,548.994445 118.154633,549.830833 117.132722,549.830833 C116.110811,549.830833 115.282389,548.994445 115.282389,547.962708 C115.282389,546.930971 116.110811,546.094583 117.132722,546.094583 Z M166.859167,515.02625 L166.859167,549.563958 L142.001722,549.563958 L142.001722,546.685937 L164.007833,546.685937 L164.007833,517.904271 L118.397333,517.904271 L118.397333,522.893229 L115.546722,522.893229 L115.546722,515.02625 L166.859167,515.02625 Z M115.546722,532.639271 C124.786833,532.639271 132.304444,540.232083 132.304444,549.563958 L129.453833,549.563958 C129.453833,541.81875 123.215278,535.517292 115.546722,535.517292 L115.546722,532.639271 Z M115.546722,525.667708 C128.597278,525.667708 139.215389,536.387917 139.215389,549.563958 L136.364778,549.563958 C136.364778,537.974583 127.025722,528.545729 115.546722,528.545729 L115.546722,525.667708 Z M115.546722,539.206875 C121.201,539.206146 125.800833,543.852396 125.800833,549.563958 L122.950222,549.563958 C122.950222,545.439792 119.628722,542.084896 115.546722,542.084896 L115.546722,539.206875 Z",
    id: "nb_wifi_cast"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNbWifiCast);
export default __webpack_public_path__ + "static/media/nb-wifi-cast.4641ffed8187d59f05ff973cfa9f516f.svg";
export { ForwardRef as ReactComponent };